import { forgetPasswordSlice } from './forgetPassword/slice';
import { workspaceSlice } from './workspace/slice';
import { combineReducers } from '@reduxjs/toolkit';
import { generalSlice } from './general/slice';
import { signUpSlice } from './signUp/slice';
import { authSlice } from './auth/slice';

const appReducer = combineReducers({
  auth: authSlice.reducer,
  signUp: signUpSlice.reducer,
  general: generalSlice.reducer,
  workspace: workspaceSlice.reducer,
  forgetPassword: forgetPasswordSlice.reducer,
});

export const reducer = (state: any, action: any) => {
  if (action.type === 'auth/logOutThunk/fulfilled') {
    state = undefined;
  }
  return appReducer(state, action);
};